const TOKEN_KEY = 'shoplattice_token';
const USER_KEY = 'shoplattice_user';

function getStorage(): Storage | null {
    if (typeof window === 'undefined') {
        return null;
    }

    return window.localStorage;
}

export function getStoredToken(): string | null {
    const token = getStorage()?.getItem(TOKEN_KEY) ?? null;
    console.log('[AuthStorage] getStoredToken:', token ? 'Token found' : 'No token');
    return token;
}

export function getStoredUser(): string | null {
    const user = getStorage()?.getItem(USER_KEY) ?? null;
    console.log('[AuthStorage] getStoredUser:', user ? 'User data found' : 'No user data');
    return user;
}

export function storeAuthSession(token: string, user: string): void {
    const storage = getStorage();
    if (!storage) {
        console.error('[AuthStorage] Storage not available');
        return;
    }

    console.log('[AuthStorage] Storing auth session');
    storage.setItem(TOKEN_KEY, token);
    storage.setItem(USER_KEY, user);
    console.log('[AuthStorage] Auth session stored successfully');
}

export function updateStoredUser(user: string): void {
    const storage = getStorage();
    if (!storage) {
        return;
    }

    storage.setItem(USER_KEY, user);
}

export function clearAuthSession(): void {
    const storage = getStorage();
    console.log('[AuthStorage] Clearing auth session');
    storage?.removeItem(TOKEN_KEY);
    storage?.removeItem(USER_KEY);
    console.log('[AuthStorage] Auth session cleared');
}
